export const tablePermissions = state => state.adminReducer.tableManager.tablePermissions

export const permissions = state => state.adminReducer.tableManager.permissions
